// Utilities
import { defineStore } from 'pinia'

interface NotificationState {
  text: string | null
  color:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'error'
    | 'info'
    | 'warning'
    | undefined
  snackbar: boolean
}

export const useNotificationStore = defineStore('notification', {
  state: (): NotificationState => ({
    text: null,
    color: 'primary',
    snackbar: false
  }),
  actions: {
    notify(
      text: string,
      color: 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning'
    ): void {
      this.text = text
      this.color = color
      this.snackbar = true
    },
    reset(): void {
      this.text = null
      this.snackbar = false
    }
  }
})
